import { render, staticRenderFns } from "./CustomDocumentSignersPanel.vue?vue&type=template&id=03e82f89&scoped=true&"
import script from "./CustomDocumentSignersPanel.vue?vue&type=script&lang=ts&"
export * from "./CustomDocumentSignersPanel.vue?vue&type=script&lang=ts&"
import style0 from "./CustomDocumentSignersPanel.vue?vue&type=style&index=0&id=03e82f89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e82f89",
  null
  
)

export default component.exports